import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {hasNextRankById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import RankProgressCard from './RankProgressCard';

export default connect(
  createStructuredSelector({
    coachId: userId,
    hasNextRank: withProps({coachId: userId})(hasNextRankById),
  }),
)(RankProgressCard);
